import React from 'react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['¿Te has encerrado en el baño a respirar porque ya no podías más?', '¿Terminas el día con culpa por haber gritado... otra vez?'];
  return <section className="py-10 md:py-20 px-5 bg-white" data-id="element-146">
      <div className="max-w-3xl mx-auto" data-id="element-147">
        <FadeIn data-id="element-148">
          <h2 className="font-serif text-2xl md:text-4xl text-brand-navy text-center mb-8" data-id="element-149">
            Para ti, que lo estás intentando todo pero sientes que nada
            funciona.
          </h2>
        </FadeIn>

        <div className="grid gap-4 mb-8" data-id="element-150">
          {points.map((text, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-151">
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-md border border-slate-100 border-l-4 border-l-brand-orange flex items-center" data-id="element-152">
                <p className="font-sans text-lg md:text-xl text-slate-700 font-medium" data-id="element-153">
                  {text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-154">
          <div className="text-center" data-id="element-155">
            <p className="font-sans text-xl md:text-2xl text-brand-navy font-bold leading-relaxed" data-id="element-156">
              No estás fallando. Lo que necesitas no es más paciencia, es un
              sistema.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}